<template>
  <div class="flex flex-col items-center justify-center h-full">
    <LoadingIndicator :loading="loading" />
    <SuccessMessage :response="response" />
    <ErrorMessage :error="error" />
    <Button v-if="!loading" :action="closeWindow" :name="'Close window'" />
  </div>
</template>

<script setup>
import SuccessMessage from '@/components/messages/SuccessMessage.vue';
import ErrorMessage from '@/components/messages/ErrorMessage.vue';
import Button from '@/components/Button.vue';
import LoadingIndicator from '@/components/LoadingIndicator.vue';

import useSquare from '@/composables/useSquare';

const closeWindow = () => {
  window.close();
};

const {
  loading,
  response,
  error,
  connect,
} = useSquare();

connect();
</script>
